import axiosIns from '@/libs/axios'

const ROOT_URL = '/Apps/dr/dr_users'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      id_branches: null,
      name: null,
      email: null,
      new_password: null,
      status: '1',
      refreshToken: null,
      downloadToken: null,
      id_user_types: null,
      id_users: null,
      logined: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      if (!data) {
        return
      }
      Object.assign(state.dataItem, {
        id: data.id ?? null,
        id_licenses: data.id_licenses ?? null,
        id_branches: data.id_branches ? parseInt(data.id_branches, 10) : null,
        name: data.name ?? null,
        email: data.email ?? null,
        new_password: null,
        status: data.status ?? '1',
        refreshToken: data.refreshToken ?? null,
        downloadToken: data.downloadToken ?? null,
        id_user_types: data.id_user_types ? parseInt(data.id_user_types, 10) : null,
        id_users: data.id_users ?? null,
        logined: data.logined ?? null,
      })
    },
    UPDATE_DATA_ITEM_FIELD(state, { field, value }) {
      state.dataItem[field] = value
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        id_branches: null,
        name: null,
        email: null,
        new_password: null,
        status: '1',
        refreshToken: null,
        downloadToken: null,
        id_user_types: null,
        id_users: null,
        logined: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify({
        where: {
          'users.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          const item = response.data.data
          if (item) {
            if (item.id_branches) item.id_branches = parseInt(item.id_branches, 10)
            if (item.id_user_types) item.id_user_types = parseInt(item.id_user_types, 10)
          }
          commit('SET_DATA_ITEM', item)
          return item
        })
        .catch(error => console.error(error))
    },
    saveData({ commit, getters }) {
      const item = getters.dataItem
      const payload = {
        id: item.id,
        id_licenses: parseInt(item.id_licenses, 10),
        id_branches: item.id_branches ? parseInt(item.id_branches, 10) : null,
        id_user_types: item.id_user_types ? parseInt(item.id_user_types, 10) : null,
        name: item.name,
        email: item.email,
        status: item.status,
      }
      if (item.new_password) {
        payload.new_password = item.new_password
      }
      const data = JSON.stringify(payload)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
  },
}
